import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 赛事荣誉榜 - pc
 */
import { defineComponent } from "vue";
import raceHonorsTitleUrl from "@/assets/img/race-honors/pc/honors-title.png";
// components
import SelectBtn from "@/components/pc/common/select-btns.vue";
import HonorSwiperBox from "@/components/pc/race-honors/honorSwiperBox.vue";
import ChampionShow from "@/pages/homePage/pc/components/championShow.vue";
//hooks
import useRaceHonors from "@/hooks/race-honors";
import useHomePageChampionship from "@/hooks/home-page-championship";
import { groupTypeOptPC, raceQuarterOptPC } from "@/config/homePage";
// config
import { averageGroup } from "@/components/common/battle-map/utils";
export default defineComponent({
  name: "PCChampionShow",
  setup() {
    //hooks
    const {
      raceHonorsState,
      groupSwitchFct,
      raceQuarterSwitchFct
    } = useRaceHonors();
    const {
      firstHalf
    } = useHomePageChampionship(raceHonorsState, {
      value: 2
    }, false);
    const battleResult = battle => {
      var _battle$redTeam;
      const res = {
        winner: null,
        loser: null
      };
      if (!battle.winner) {
        return res;
      }
      if (battle.winner === ((_battle$redTeam = battle.redTeam) === null || _battle$redTeam === void 0 ? void 0 : _battle$redTeam.teamId)) {
        res.winner = battle.redTeam;
        res.loser = battle.blueTeam;
      } else {
        res.winner = battle.blueTeam;
        res.loser = battle.redTeam;
      }
      return res;
    };
    return () => {
      var _firstVal$, _firstVal$2;
      const [firstVal] = averageGroup(firstHalf.value);

      // 决赛数据
      const lastBattle = (firstVal === null || firstVal === void 0 ? void 0 : (_firstVal$ = firstVal[2]) === null || _firstVal$ === void 0 ? void 0 : _firstVal$[0]) || {};
      const lastBattleRes = battleResult(lastBattle);

      // 季军赛数据
      const thirdPlace = (firstVal === null || firstVal === void 0 ? void 0 : (_firstVal$2 = firstVal[1]) === null || _firstVal$2 === void 0 ? void 0 : _firstVal$2[0]) || {};
      const thirdPlaceRes = battleResult(thirdPlace);
      // 第三名
      const third = thirdPlaceRes.winner;
      // 第二名
      const second = lastBattleRes.loser;
      // 第一名
      const champion = lastBattleRes.winner;
      const teamList = [champion, second, third];
      return _createVNode("div", {
        "class": "pc-information-honor"
      }, [_createVNode(ChampionShow, {
        "id": "honor-box"
      }, null), _createVNode("div", {
        "class": "title-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": raceHonorsTitleUrl
      }, null)]), _createVNode("div", {
        "class": "select-btn"
      }, [_createVNode(SelectBtn, {
        "onClick": raceQuarterSwitchFct,
        "options": raceQuarterOptPC,
        "dataValue": raceHonorsState.raceQuartertype
      }, null), _createVNode(SelectBtn, {
        "class": "btn-center",
        "onClick": groupSwitchFct,
        "options": groupTypeOptPC,
        "dataValue": raceHonorsState.groupType,
        "defaultOption": groupTypeOptPC[raceHonorsState.groupType - 1]
      }, null)]), champion ? _createVNode(HonorSwiperBox, {
        "zone1Teams": teamList,
        "groupType": groupTypeOptPC[raceHonorsState.groupType - 1],
        "raceQuarter": raceQuarterOptPC[raceHonorsState.raceQuartertype - 1]
      }, null) : _createVNode("div", {
        "class": "not-finished"
      }, [_createTextVNode("\u656C\u8BF7\u671F\u5F85\xB7\xB7\xB7\xB7")])]);
    };
  }
});